<p>
  {{ message() }}
</p>
